export function getUsers(users) {
    return { type: 'GET_USERS', users };
}
